import pkg from '@/package.json';

type PackageInfo = {
  name: string;
  version: string;
  description?: string;
  private?: boolean;
};

export const getPackageInfo = (): PackageInfo => {
  return pkg;
};
